/**
 * @author maydays
 * @description 登录、获取用户信息、退出登录、清除accessToken逻辑
 */
import { getRouterList, getUserInfo, login } from '@/api/user'
import CONFIG from '@/config'
import store from '@/store'
import { getActualName, getAdmin, getAvatar, getPermissions, getUserId, getUserName, setActualName, setAdmin, setAvatar, setUserId, setUserName, setVisitedRoutes } from '@/utils/auth'
import { flat, getLocal, removeLocal, setLocal } from '@/utils/index'
import { Message, Notification } from '@arco-design/web-vue'

const { title, tokenName } = CONFIG
const state = () => ({
  accessToken: getLocal(tokenName),
  menuList: [],
  permissions: getPermissions(),
  admin: getAdmin(),
  userId: getUserId(),
  avatar: getAvatar(),
  // 账号名字
  username: getUserName(),
  // 账号全称
  actualName: getActualName(),
  //平铺后台返回的路由
  flatMenuList: [],
  isSupplier: false,
  USER_INFO: null,
})
const getters = {
  accessToken: state => state.accessToken,
  // 账号名字
  username: state => state.username,
  // 账号全称
  actualName: state => state.actualName,
  userId: state => state.userId,
  menuList: state => state.menuList,
  permissions: state => state.permissions,
  flatMenuList: state => state.flatMenuList,
  isSupplier: state => state.isSupplier,
  deptInfo: state => state.USER_INFO.qwDeptInfo,
  userInfo: state => ({ userId: state.userId, userName: state.actualName || state.username }),
  USER_INFO: state => state.USER_INFO,
}
const mutations = {
  /**
   * @author maydays
   * @description 设置accessToken
   * @param {*} state
   * @param {*} accessToken
   */
  setAccessToken(state, accessToken) {
    state.accessToken = accessToken
    setLocal(tokenName, accessToken)
  },
  /**
   * @author maydays
   * @description 设置用户名
   * @param {*} state
   * @param {*} username
   */
  setUsername(state, username) {
    state.username = username
  },
  setActualName(state, actualName) {
    state.actualName = actualName
  },
  setMenu(state, value) {
    state.menuList = value
    localStorage.setItem('menuList', JSON.stringify(value))
  },
  setPrem(state, value) {
    state.permissions = value
    localStorage.setItem('permissions', JSON.stringify(value))
  },
  setFlatMenuList(state, value) {
    state.flatMenuList = value
  },
  SET_ROLE(state, admin) {
    state.admin = admin
  },
  SET_AVATAR(state, avatar) {
    state.avatar = avatar
  },
  SET_USERID(state, userId) {
    state.userId = userId
  },
  SET_IS_SUPPLIER(state, value) {
    state.isSupplier = value
  },
  SET_USER_INFO(state, payload) {
    state.USER_INFO = payload
  },
}
const actions = {
  /**
   * @author maydays
   * @description 登录
   * @param {*} { commit }
   * @param {*} userInfo
   */
  async login({ commit }, userInfo) {
    // 登录先清除之前存储的token
    commit('setAccessToken', '')
    const { data, code } = await login(userInfo)
    if (code === '200') {
      const accessToken = data.access_token
      commit('setAccessToken', 'bearer ' + accessToken)
      const hour = new Date().getHours()
      const thisTime = hour < 8 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 18 ? '下午好' : '晚上好'
      Notification.success({
        title: `欢迎登录${title}`,
        content: `${thisTime}！`,
      })
      return true
    } else {
      Message.error(`登录失败：账号或密码错误`)
      return false
    }
  },
  /**
   * @author maydays
   * @description 获取用户信息接口 这个接口非常非常重要，如果没有明确底层前逻辑禁止修改此方法，错误的修改可能造成整个框架无法正常使用
   * @param {*} { commit, dispatch, state }
   * @returns
   */
  async getUserInfo({ commit }) {
    const { data, code } = await getUserInfo()
    if (code !== '200') {
      Message.error(`验证失败，请重新登录...`)
      return false
    }
    const { username, id, actualName, avatar, permNames, roleCodes } = data
    if (Number(getUserId()) !== Number(id)) {
      setVisitedRoutes([])
      store.commit('tagsBar/clearVisitedRoutes')
    }
    commit('setUsername', username)
    commit('setActualName', actualName)
    commit('SET_AVATAR', avatar)
    commit('SET_ROLE', actualName)
    commit('SET_USERID', id)
    commit('setPrem', permNames || [])
    commit('SET_USER_INFO', data)
    setAdmin(actualName)
    setAvatar(avatar)
    setUserId(id)
    setUserName(username)
    setActualName(actualName)
    commit('SET_IS_SUPPLIER', roleCodes.includes('供应商'))
    return true
  },

  /**
   * @author maydays
   * @description 退出登录
   * @param {*} { dispatch }
   */
  async logout({ dispatch }) {
    // await logout(state.accessToken)
    await dispatch('resetAll')
  },
  /**
   * @author maydays
   * @description 重置accessToken、roles、ability、router等
   * @param {*} { commit, dispatch }
   */
  async resetAll({ dispatch }) {
    await dispatch('setAccessToken', '')
    removeLocal(tokenName)
  },
  /**
   * @author maydays
   * @description 设置token
   */
  setAccessToken({ commit }, accessToken) {
    commit('setAccessToken', accessToken)
  },
  /**
   * @author maydays
   * @description 设置token
   */
  setMenu({ commit }) {
    return new Promise((resolve, reject) => {
      getRouterList()
        .then(res => {
          if (res.code === '200') {
            commit('setMenu', res.data)
            commit('setFlatMenuList', flat(res.data))
            resolve(res)
          } else {
            reject()
          }
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
}
export default { state, getters, mutations, actions }
